import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/waitlistly/waitlistly/node_modules/next/dist/client/link.js");
